module.exports = __webpack_public_path__ + "static/TrustYou-c57650a21b98b0445b3f719024d8d619.svg";